import { HttpResourceRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { endpoints } from '../../../../../environments/endpoints';
import { ApiService } from '../../../Shared/Services/api.service';
import { AllDemandsFilters } from '../Interfaces/all-demands-filters.interface';
import { ReportDemandListResponse } from '../Interfaces/report-demand-list.interface';
import { ReportFilterOptionsResponse } from '../Interfaces/report-filter-options.interface';
import { ReportDetailResponse } from '../Types/report-detail-response.type';
import { ReportSubjectTab } from '../Types/report-subject-tab.type';
import { buildAllDemandsHttpParams } from '../Shared/all-demands-http-params.util';

@Injectable({ providedIn: 'root' })
export class DemandReportService {
  private readonly _api = inject(ApiService);

  list(
    tab: ReportSubjectTab,
    filters: AllDemandsFilters,
    skipLoading: boolean = true,
  ): HttpResourceRequest {
    return this._api.get<ReportDemandListResponse>(this._routes(tab).index, {
      params: buildAllDemandsHttpParams(filters),
      skipLoading,
    });
  }

  filterOptions(tab: ReportSubjectTab): HttpResourceRequest {
    return this._api.get<ReportFilterOptionsResponse>(this._routes(tab).filterOptions, {
      skipLoading: true,
      skipError: true,
    });
  }

  show(tab: ReportSubjectTab, demandId: string, skipLoading: boolean = true): HttpResourceRequest {
    return this._api.get<ReportDetailResponse>(this._routes(tab).show(demandId), { skipLoading });
  }

  private _routes(tab: ReportSubjectTab) {
    return tab === 'application'
      ? endpoints.api.reports.applicationDemands
      : endpoints.api.reports.groupDemands;
  }
}
